import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack, useNotifications } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../../common/useOrdersModuleApi";
import { validateDeliveryFolder } from "../../../create/common/validation/validateDeliveryFolder";
import { OrderListingContext } from "../../context/OrderListingContext";
import { OrderListingItem } from "../../OrderListingItem";

interface UpdateOrderDeliveryFolderFormInputs {
    deliveryFolder: string;
}

export interface UpdateOrderDeliveryFolderFormProps {
    item: OrderListingItem;
    onCancel(): void;
    onSubmit(): void;
}

export const UpdateOrderDeliveryFolderForm: React.VFC<UpdateOrderDeliveryFolderFormProps> = ({
    item,
    onCancel,
    onSubmit
}: UpdateOrderDeliveryFolderFormProps) => {
    const { control, errors, formState, handleSubmit } = useForm<UpdateOrderDeliveryFolderFormInputs>({
        defaultValues: {
            deliveryFolder: item.deliveryFolder
        },
        criteriaMode: "all"
    });

    const { success } = useNotifications();
    const { updateOrderDeliveryFolder } = useOrdersModuleApi();
    const { updateDeliveryFolder } = useContext(OrderListingContext);

    const handleUpdateOrderDeliveryFolder = async ({ deliveryFolder }: UpdateOrderDeliveryFolderFormInputs) => {
        await updateOrderDeliveryFolder({ orderId: item.id, deliveryFolder });
        updateDeliveryFolder(item.id, deliveryFolder);

        onSubmit();
        success("Order rejected");
    };

    return (
        <Stack>
            <Form onSubmit={handleSubmit(handleUpdateOrderDeliveryFolder)}>
                <Stack verticalAlign="space-between">
                    <FormFields>
                        <FormTextField
                            label="Delivery Folder"
                            control={control}
                            name="deliveryFolder"
                            errors={errors}
                            rules={{ required: "Enter Delivery Folder", validate: validateDeliveryFolder }}
                            multiline={true}
                        />
                        <FormActions onCancel={onCancel} isLoading={formState.isSubmitting || formState.isValidating} />
                    </FormFields>
                </Stack>
            </Form>
        </Stack>
    );
};
